import React, { useEffect } from "react";
import { useRegion } from "./Hooks";

function Region({ set, data = {} }) {
  const {
    loading,
    citys,
    regions,
    provinec,
    getProvince,
    getRegion,
    getCity,
    setForm,
    form,
  } = useRegion();
  useEffect(() => {
    getProvince();
  }, []);
  return (
    <>
      {data && data.region && data.region[0] && (
        <div className="row">
          <div className="col">
            <h6>
              مقادیر قبلی :{" "}
              {`${data.province[0].name} - ${data.city[0].name} - ${data.region[0].name}`}
            </h6>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-4 mb-2">
          <label htmlFor="">استان</label>
          <select
            onChange={({ target: { value } }) => getCity(value)}
            className="form-control"
            defaultValue={data.province_id}
          >
            <option value="">انتخاب کنید</option>
            {provinec.map((element, key) => (
              <option key={key} value={element.id}>
                {element.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 mb-2">
          <label htmlFor="">شهرستان</label>
          <select
            className="form-control"
            onChange={({ target: { value } }) => getRegion(value)}
            defaultValue={data.city_id}
          >
            <option value="">انتخاب کنید</option>

            {citys.map((element, key) => (
              <option key={key} value={element.id}>
                {element.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-4 mb-2">
          <label htmlFor="">منطقه</label>
          <select
            className="form-control"
            onChange={({ target: { value } }) => {
              setForm({ ...form, region_id: value });
              set({ ...data, ...form, region_id: value });
            }}
            defaultValue={data.region_id}
          >
            <option value="">انتخاب کنید</option>

            {regions.map((element, key) => (
              <option
                key={key}
                selected={form.region_id == element.id}
                value={element.id}
              >
                {element.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}

export default Region;
